module.exports = __webpack_public_path__ + "img/meet-your-dashboards.45798578.png";